export default __webpack_public_path__ + "static/media/S_A_True.604ac836.jpg";